export interface ICreator {
  _id: string;
  name: string;
  profilePicUrl?: string;
}

export interface IConsultationEvent {
  _id: string;
  customSlotDates?: string[];
  mango: {
    _id: string;
    title: string;
  };
  creator: ICreator;
  noOfSlotsLimit: number;
  //   slotsType: 'weekly' | 'custom';
  //   weeklySlotTimings?: WeeklySlotTimimg[];
  //   customSlotTimings?: CustomSlotTimimg[];
  title: string;
  description: string;
  meetingPlatform: 'tagmango' | 'custom';
  meetingUrl: string;
  duration: number;
  createdAt: string;
  updatedAt: string;
  //   __v: number;
  //   weeklySlotStartDate?: string;
  //   weeklySlotEndDate?: string;
  slots: IConsultationSlot[];
}

// export interface WeeklySlotTimimg {
//   _id: string;
//   dayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6;
//   startTime: string;
//   endTime: string;
// }

// export interface CustomSlotTimimg {
//   _id: string;
//   date: string;
//   startTime: string;
//   endTime: string;
// }

export interface IConsultationSlot {
  _id: string;
  locked: boolean;
  date: string;
  startTime: string;
  endTime: string;
  utcStartTime: string;
  utcEndTime: string;
  available: boolean;
  subscriptionEligibility: {
    allowedToBook: boolean;
    allowedToPurchase: boolean;
    message: string;
    reason: string;
  };
}

export enum SlotBookingStatus {
  BOOKING = 'BOOKING',
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  BOOKING_FAILED = 'BOOKING_FAILED',
  AVAILABLE = 'AVAILABLE',
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  FAILED_TO_CHECK_AVAILABILITY = 'FAILED_TO_CHECK_AVAILABILITY',
  NOT_FOUND = 'NOT_FOUND',
}

export type SlotBookingStatusType = `${SlotBookingStatus}`;

export enum BookConsultationSlotStatus {
  AVAILABLE = 'AVAILABLE',
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  FAILED_TO_CHECK_AVAILABILITY = 'FAILED_TO_CHECK_AVAILABILITY',
  NOT_FOUND = 'NOT_FOUND',
}

export type BookConsultationSlotStatusType = `${BookConsultationSlotStatus}`;

export interface ICheckSlotAvailabilityResult {
  available: boolean;
  status: BookConsultationSlotStatusType;
  slotLockId?: string;
}

export interface IBookConsultationSlotResult {
  message: string;
  status: BookConsultationSlotStatusType;
  videocall: string;
}

export interface IConsultationPendingEvent extends IConsultationEvent {
  bookings: number;
}
